import React from "react";
import MainContent from "../../components/mainContent/MainContent";
import { GestionPeriodosContent } from "./components/GestionPeriodosContent";

export default function GestionPeriodos() {
    return (
        <>
            <MainContent
                component={<GestionPeriodosContent />}
                titulo={"Gestión de Periodos"}
                noBackground
                tableMaxWidth
            />
        </>
    );
}
